import { Box, type BoxProps, ButtonGroup, Flex } from "@chakra-ui/react";
import type { FC } from "react";

import { WorkflowButton } from "@/components/workflow/WorkflowButton";
import { Heading } from "@equidefi/ui";

type WorkflowContainerProps = {
  title?: string;
  onContinue?: () => void;
  buttonLabel?: string;
  buttonProps?: React.ComponentProps<typeof WorkflowButton>;
} & BoxProps;

export const WorkflowContainer: FC<WorkflowContainerProps> = ({
  children,
  title,
  onContinue,
  buttonLabel = "Continue",
  buttonProps,
  ...rest
}) => {
  return (
    <Flex direction="column" align="center" justify={{ base: "start", lg: "center" }} w="full" minH="full">
      <Box maxWidth="560px" w="full" px={{ base: 4, lg: 0 }} py={{ base: 4, md: 6 }} {...rest}>
        {title && (
          <Heading textStyle="h1" m={0} fontWeight="700">
            {title}
          </Heading>
        )}
        {children}

        {onContinue && (
          <ButtonGroup gap={2} w="full">
            <WorkflowButton onClick={onContinue} mb={{ base: 0, lg: 4 }} {...buttonProps}>
              {buttonLabel}
            </WorkflowButton>
          </ButtonGroup>
        )}
      </Box>
    </Flex>
  );
};
